export default function EmptyState({ title, description, icon: Icon, action, testId }) {
    return (
        <div
            className="border border-dashed border-ink-300 bg-white/60 rounded-sm py-16 px-8 text-center"
            data-testid={testId || "empty-state"}
        >
            {Icon && (
                <div className="w-12 h-12 mx-auto mb-4 rounded-sm bg-ink-100 flex items-center justify-center text-ink-500">
                    <Icon size={20} strokeWidth={1.5} />
                </div>
            )}
            <div className="font-heading text-xl text-ink-900 mb-2">{title}</div>
            {description && <div className="text-sm text-ink-500 max-w-md mx-auto">{description}</div>}
            {action && <div className="mt-6">{action}</div>}
        </div>
    );
}
